/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type special_allocations_UpdateAbsenceRequest = {
    /**
     * ChildID to update
     */
    child_id?: string;
    /**
     * Comment to update (max 500 characters)
     */
    comment?: string;
    /**
     * ExpectedUpdatedAt for optimistic concurrency control - server will check this matches the current updated_at and return 409 if different
     */
    expected_updated_at?: string;
    /**
     * FromDatetime to update. Send a plain RFC3339 date-time string, or a
     * date-only string ("2006-01-02").
     * example: "2024-01-15T09:00:00Z"
     */
    from_datetime?: string;
    /**
     * FullDay to update
     */
    full_day?: boolean;
    /**
     * Reason to update (one of: ILLNESS, VACATION, OTHER, UNKNOWN)
     */
    reason?: special_allocations_UpdateAbsenceRequest.reason;
    /**
     * ToDatetime to update. Send a plain RFC3339 date-time string, or a
     * date-only string ("2006-01-02").
     * example: "2024-01-15T17:00:00Z"
     */
    to_datetime?: string;
};
export namespace special_allocations_UpdateAbsenceRequest {
    /**
     * Reason to update (one of: ILLNESS, VACATION, OTHER, UNKNOWN)
     */
    export enum reason {
        ILLNESS = 'ILLNESS',
        VACATION = 'VACATION',
        OTHER = 'OTHER',
        UNKNOWN = 'UNKNOWN',
    }
}

